import { render, staticRenderFns } from "./RunContinue.vue?vue&type=template&id=383d684e&scoped=true&"
import script from "./RunContinue.vue?vue&type=script&lang=js&"
export * from "./RunContinue.vue?vue&type=script&lang=js&"
import style0 from "./RunContinue.vue?vue&type=style&index=0&id=383d684e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383d684e",
  null
  
)

export default component.exports